import React, { useState } from "react";
import {
  Col,
  Input,
  Row,
  Form,
  DatePicker,
  Select,
  Checkbox,
  TimePicker,
  Button,
  message,
  Table,
  Radio,
  Modal,
} from "antd";
import dayjs from "dayjs";
import CommonFunctions from "../../Shared/CommonFunctions";
import PatientService from "../../../Services/PatientService";
import enrollmentServices from "../../../Services/enrollmentServices";
import AppointmentService from "../../../Services/AppointmentService";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserWalletDetails } from "../../../Redux/actions/UserActions";

function AddExistingPatient({
  onClose,
  form,
  setMobileNumber,
  mobileNumber,
  handleKeyPress,
  getAppointmentList,
  radioValue,
  isVisible,
  setIsVisible,
  paymentType,
  setPaymentType,
  paymentReceived,
  setPaymentReceived,
  callType,
  setCallType,
}) {
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const [filteredPatient, setFilteredPatient] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [save, setSave] = useState(false);
  const [endTime, setEndTime] = useState(null);
  const [submitType, setSubmitType] = useState(null);

  const [visitModal, setVisitModal] = useState(false);
  const [hidePayFields, setHidePayFields] = useState(false);
  const [consReason, setConsReason] = useState("");
  const [consCode, setConsCode] = useState("");
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const { walletDetails, walletAmount } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await AppointmentService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleConsReasonChange = (e) => {
    setConsReason(e.target.value);
    let value = e.target.value;
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const handleConsSelectChange = (reason) => {
    setConsReason(reason?.chiefComplaint ? reason?.chiefComplaint : "");
    setConsCode(reason?.complaintCode ? reason?.complaintCode : "");
    setConsultationReasonList([]);
  };

  const onPaymentTypeChange = (value) => {
    setPaymentType(value);

    if (value === "Cash") {
      //changed
      setPaymentReceived(true);
      form.setFieldsValue({ paymentConsultation: "BC" });
    } else if (value === "VirtualCash") {
      let payload = {
        userId: loginResultObject.user.userId,
        account_Id: loginResultObject.user.account_Id,
        clinic_Id: loginResultObject.user.clinic_Id,
      };
      dispatch(fetchUserWalletDetails(payload));
      setPaymentReceived(true);
      form.setFieldsValue({ paymentConsultation: "BC" });
    } else if (value === "Digital") {
      form.setFieldsValue({ paymentConsultation: "BC" });
      setPaymentReceived(false);
    } else {
      setPaymentReceived(false);
      form.setFieldsValue({ paymentConsultation: null });
    }
  };

  const handleCallTypeChange = (value) => {
    setCallType(value);
    if (value === "APPT_INPERSON") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.inpersonFee
          ? loginResultObject.user.inpersonFee
          : 0,
      });
    } else if (value === "APPT_VIDEO") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.videoFee
          ? loginResultObject.user.videoFee
          : 0,
      });
    } else if (value === "APPT_HOMEVISIT") {
      form.setFieldsValue({
        consultationFee: loginResultObject.user.homeVisitFee
          ? loginResultObject.user.homeVisitFee
          : 0,
      });
    }
  };

  const hideFilter = async () => {
    if (selectedPatient === null) {
      message.error("Select a patient to send the invite");
      return;
    }
    setSave(true);
    let payload = {
      patientId: selectedPatient.patientId,
      userId: loginResultObject.user.userId,
      appointmentDate: dayjs().format("MM/DD/YYYY"),
    };
    let result = await enrollmentServices.CheckFollowUp(payload);
    if (result.data == 1) {
      setVisitModal(true);
      setSave(false);
    } else {
      if (selectedPatient) {
        form.setFieldsValue({
          ...selectedPatient,
        });
      }
      setIsVisible(false);
      setSave(false);
    }
  };

  const cancelFollowUp = () => {
    if (selectedPatient) {
      form.setFieldsValue({
        ...selectedPatient,
      });
    }
    setIsVisible(false);
    setVisitModal(false);
    setHidePayFields(false);
  };

  const cancelFilter = () => {
    setIsVisible(false);
    setMobileNumber("");
    setSelectedPatient(null);
  };

  const handleRadioChange = (record) => {
    if (!record) {
      setSelectedPatient(null);
    } else {
      setSelectedPatient(record);
    }
  };

  const handleSearch = async () => {
    setSave(true);
    if (mobileNumber === "") {
      message.error("Enter patient mobile number to filter");
      setSave(false);
      return;
    }

    const isValidMobile = /^\d{1,11}$/.test(mobileNumber);

    if (!isValidMobile) {
      message.error("Mobile number must contain digits only, with no spaces.");
      setSave(false);
      return;
    }

    try {
      const payload = {
        mobile: isNaN(mobileNumber) ? null : mobileNumber,
      };

      const result = await PatientService.PatientListFilter(payload);
      setFilteredPatient(result.data);
      setIsVisible(true);
      setSave(false);
    } catch (error) {
      setFilteredPatient([]);
      setSave(false);
      console.error("Failed to fetch patient list:", error);
      message.error("Something went wrong while fetching patient data.");
    }
  };

  const handleCancelClick = () => {
    setMobileNumber("");
    onClose();
  };

  const disabledDate = (current) => {
    return current && current < new Date().setHours(0, 0, 0, 0);
  };

  const handleExistingInvite = async (payload) => {
    setSave(true);

    let data = {
      consultationReason: consReason,
      complaintCode: consCode,
      createdBy: loginResultObject.user.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      email: payload?.email,
      account_Id: loginResultObject.user.account_Id,
      clinic_Id: loginResultObject.user.clinic_Id,
      firstName: payload?.firstName,
      lastName: payload?.lastName,
      specialityCode: loginResultObject.user?.specialityCode,
      mobile: payload?.mobile,
      modifiedBy: loginResultObject.user.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      patientId: selectedPatient.patientId,
      paymentConsultation: payload?.paymentConsultation,
      paymentType: payload?.paymentType,
      appointmentDate: CommonFunctions.convertDate(payload.appointmentDate),
      startTime: dayjs(payload.startTime).local().format("hh:mm A"),
      endTime: dayjs(payload.endTime).local().format("hh:mm A"),
      serviceName:
        payload.serviceCode === "APPT_VIDEO"
          ? "Video Consultation"
          : payload.serviceCode === "APPT_INPERSON"
          ? "Inperson Consultation"
          : payload.serviceCode === "APPT_HOMEVISIT"
          ? "Home Visit Consultation"
          : "",
      serviceCode: payload.serviceCode,
      consultationFee: payload.consultationFee,
      totalAmount: payload.consultationFee,
      userId: loginResultObject.user.userId,
      patientType: "E",
      patientRegFeeYN: "N",
    };

    if (submitType === "1") {
      setSave(true);
      data.status = 0;
      data.paymentReceived = "N";
      CommonFunctions.ExisTingPatientPayment(data)
        .catch((error) => {
          console.error("An error occurred:", error);
          message.error("An Error occurred, try again");
        })
        .finally(() => {
          setSave(false);
        });
    } else if (submitType === "2") {
      payload.paymentType = paymentType;
      if (payload.paymentType == "Cash" && !paymentReceived) {
        message.error("Confirm Payment received by clicking the check box");
        setSave(false);
        return;
      }

      if (payload.paymentType == "VirtualCash") {
        payload.walletId = walletDetails.walletId;
        payload.txnType = "DEBIT";
        if (walletAmount < data.totalAmount) {
          message.error("Required Amount not available in the wallet");
          setSave(false);
          return;
        }
      }

      setSave(true);
      try {
        if (
          payload.paymentType == "Cash" &&
          payload.paymentConsultation == "BC"
        ) {
          data.paymentReceived = paymentReceived ? "Y" : "N";
          data.status = 1;
        } else if (
          payload.paymentType == "Digital" &&
          payload.paymentConsultation == "BC"
        ) {
          data.paymentReceived = "N";
          data.status = 0;
        } else if (
          payload.paymentType == "VirtualCash" &&
          payload.paymentConsultation == "BC"
        ) {
          data.status = 1;
          data.walletId = walletDetails.walletId;
          data.txnType = "DEBIT";
          data.paymentType = "VirtualCash";
          data.paymentReceived = "Y";
        }
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          message.error("Sending Invitation Failed, Retry");
          setSave(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("Invitation sent Successfully");
          setMobileNumber("");
          setSelectedPatient(null);
          onClose();
          form.resetFields();
          getAppointmentList();
        }
      } catch (error) {
        console.error("An error occurred:", error);
        message.error("An Error occured please try again");
      } finally {
        setSave(false);
      }
    } else if (submitType == "3") {
      // share payment link"
      setSave(true);
      try {
        if (data.paymentType == "Digital" && data.paymentConsultation == "AC") {
          message.error(
            "Share payment link is not available for After Consultation"
          );
          return;
        }
        data.status = 0;
        data.paymentType = "Share_Link";
        const result = await enrollmentServices.Invite(data);
        if (result.data.code === "FAILED") {
          message.error("Sending Invitation Failed, Retry");
          setSave(false);
          return;
        }
        if (result.data.code === "SUCCESS") {
          message.success("Payment Link and invitation sent Successfully");
          setMobileNumber("");
          setSelectedPatient(null);
          onClose();
          form.resetFields();
          getAppointmentList();
        }
      } catch (error) {
        console.error("An error occurred:", error);
        message.error("An Error occured please try again");
      } finally {
        setSave(false);
      }
    }
  };

  const handleFollowUpVisit = async (payload) => {
    setSave(true);

    let data = {
      consultationReason: consReason,
      complaintCode: consCode,
      createdBy: loginResultObject.user.userId,
      createdDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      paymentConsultation: "BC",
      email: selectedPatient.email ? selectedPatient.email : "",
      account_Id: loginResultObject.user.account_Id,
      clinic_Id: loginResultObject.user.clinic_Id,
      firstName: payload.firstName ? payload.firstName : "",
      lastName: payload.lastName ? payload.lastName : "",
      specialityCode: loginResultObject.user?.specialityCode,
      mobile: payload.mobile,
      modifiedBy: loginResultObject.user.userId,
      modifiedDate: CommonFunctions.convertUTCDate(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      ),
      patientId: selectedPatient.patientId,
      paymentType: "FullDiscount",
      appointmentDate: CommonFunctions.convertDate(payload.appointmentDate),
      startTime: dayjs(payload.startTime).local().format("hh:mm A"),
      endTime: dayjs(payload.endTime).local().format("hh:mm A"),
      serviceName:
        payload.serviceCode === "APPT_VIDEO"
          ? "Video Consultation"
          : payload.serviceCode === "APPT_INPERSON"
          ? "Inperson Consultation"
          : payload.serviceCode === "APPT_HOMEVISIT"
          ? "Home Visit Consultation"
          : "",
      serviceCode: payload.serviceCode,
      consultationFee: payload.consultationFee,
      totalAmount: 0,
      status: 1,
      userId: loginResultObject.user.userId,
      patientType: "E",
      patientRegFeeYN: "N",
      paymentReceived: "N",
      appointmentType: "F",
    };

    const result = await enrollmentServices.Invite(data);

    if (!result.data) {
      message.error("Registration Failed, Retry");
      return;
    }
    if (result.data.code === "SUCCESS") {
      message.success("Invitation sent Successfully");
      onClose();
      getAppointmentList();
      setMobileNumber("");
      setSelectedPatient(null);
    }
  };

  const handleMobileNumber = (event) => {
    setMobileNumber(event.target.value);
  };

  const handleStartTimeChange = (time) => {
    if (time) {
      const endTime = dayjs(time).add(15, "minutes");
      setEndTime(endTime);
      form.setFieldsValue({ endTime });
    } else {
      setEndTime(null);
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "patientId",
      render: (patientId, record) => (
        <Checkbox
          checked={selectedPatient && selectedPatient.patientId === patientId}
          onChange={() => handleRadioChange(record)}
        />
      ),
    },
    {
      title: "Patient ID",
      dataIndex: "patientId",
      key: "patientId",
    },
    {
      title: "Name",
      dataIndex: "firstName",
      key: "name",
    },
    {
      title: "Email ID",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },
  ];

  const onPaymentStatusChange = () => {
    setPaymentReceived(!paymentReceived);
  };

  const handleSubmitType = (type) => {
    setSubmitType(type);
  };

  return (
    <div>
      <div>
        <div className="flex gap-2 mt-4 ">
          {radioValue === "domainPatients" ? (
            <Input
              onKeyDown={handleKeyPress}
              placeholder="Enter Patient Mobile number"
              name="mobile"
              className="custom-input"
              value={mobileNumber}
              onChange={handleMobileNumber}
            ></Input>
          ) : (
            <Input
              placeholder="Enter Patient Mobile number"
              className="custom-input"
              name="mobile"
              value={mobileNumber}
              onChange={handleMobileNumber}
              onKeyDown={handleKeyPress}
            />
          )}
          <button
            className="h-10 px-10 rounded-md text-white bg-brand-primaryColor"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>

        <div className={isVisible ? "block" : "hidden"}>
          {filteredPatient.length > 0 ? (
            <table className="w-full border-collapse border border-gray-300 mt-2">
              <thead className="bg-[#F5FEFA]">
                <tr>
                  <th className="border border-gray-300 p-2"></th>
                  <th className="border border-gray-300 p-2">Patient ID</th>
                  <th className="border border-gray-300 p-2">Name</th>
                  <th className="border border-gray-300 p-2">Mobile</th>
                </tr>
              </thead>
              <tbody>
                {filteredPatient.map((record) => (
                  <tr
                    key={record.patientId}
                    className={`cursor-pointer ${
                      selectedPatient &&
                      selectedPatient.patientId === record.patientId
                        ? "bg-gray-200"
                        : ""
                    }`}
                    onClick={() => handleRadioChange(record)}
                  >
                    <td className="border border-gray-300 p-2">
                      <Checkbox
                        checked={
                          selectedPatient &&
                          selectedPatient.patientId === record.patientId
                        }
                        onChange={() => handleRadioChange(record)}
                      />
                    </td>
                    <td className="border border-gray-300 p-2">
                      {record.patientId}
                    </td>
                    <td className="border border-gray-300 p-2">
                      {record.firstName}
                    </td>
                    <td className="border border-gray-300 p-2">
                      {record.mobile}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center text-gray-500 py-4">
              No patient found
            </div>
          )}
          <div className="w-full flex justify-end gap-2">
            <button
              className="p-2 rounded-md border border-[#189FAA] w-24 bg-white text-black justify-end "
              onClick={cancelFilter}
            >
              cancel
            </button>

            <button
              className="p-2 rounded-md text-white w-24 bg-brand-primaryColor"
              onClick={hideFilter}
            >
              Ok
            </button>
          </div>
        </div>
      </div>
      {save && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <Form
        className=" mt-7"
        name="trigger"
        layout="vertical"
        form={form}
        onFinish={!hidePayFields ? handleExistingInvite : handleFollowUpVisit}
        initialValues={{
          serviceCode: "APPT_VIDEO",
          paymentType: "Cash",
          paymentConsultation: "BC",
          consultationFee: loginResultObject.user.videoFee,
          appointmentDate: dayjs(),
          startTime: dayjs(),
          endTime: dayjs().add(15, "minutes"),
        }}
      >
        <div className="rounded-lg bg-white p-3 shadow-lg">
          <Row gutter={24}>
            <Col span={12}>
              <div className="relative">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Name <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter First Name!",
                    },
                  ]}
                >
                  <Input
                    disabled
                    type="text"
                    placeholder=""
                    className="w-full mt-1 rounded-lg px-4 py-2"
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Mobile <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="mobile"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Mobile Number!",
                    },
                  ]}
                >
                  <Input
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    type="text"
                    maxLength={15}
                    onKeyDown={handleKeyPress}
                    placeholder="Mobile"
                    disabled
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        </div>
        <div className="rounded-lg bg-white p-3 mt-5 shadow-lg">
          <Row gutter={24}>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Appointment Date <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="appointmentDate"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter appointmentDate!",
                    },
                  ]}
                >
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    defaultValue={dayjs()}
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    disabledDate={disabledDate}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-3">
                <span className="absolute -top-2 z-10 left-3 bg-white px-1  text-xs">
                  Service Type <span className="text-red-500">*</span>
                </span>

                <Form.Item
                  name="serviceCode"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Consultation Type!",
                    },
                  ]}
                >
                  <Select
                    defaultValue={"APPT_VIDEO"}
                    showSearch={false}
                    className="w-full"
                    placeholder="Search to Consltations"
                    onChange={handleCallTypeChange}
                  >
                    <Select.Option value="APPT_VIDEO">Video</Select.Option>
                    <Select.Option value="APPT_INPERSON">
                      In-person
                    </Select.Option>
                    <Select.Option value="APPT_HOMEVISIT">
                      Home Visit
                    </Select.Option>
                  </Select>
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  Start Time <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="startTime"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Start Time!",
                    },
                  ]}
                >
                  <TimePicker
                    use12Hours
                    format="h:mm a"
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    onChange={handleStartTimeChange}
                    minuteStep={5}
                    needConfirm={false}
                    allowClear={false}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-1 z-10 left-3 bg-white px-1  text-xs">
                  End Time <span className="text-red-500">*</span>
                </span>
                <Form.Item
                  name="endTime"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter End Time!",
                    },
                  ]}
                >
                  <TimePicker
                    id="endTime"
                    use12Hours
                    format="h:mm a"
                    className="w-full mt-1 rounded-lg px-4 py-2"
                    value={endTime}
                    minuteStep={5}
                    needConfirm={false}
                    allowClear={false}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col className={`${true ? "block" : "hidden"}`} span={12}>
              <div className="relative mt-2">
                <span className="absolute -top-3 z-10 left-2 bg-white px-1 ">
                  Reason for Consultation
                </span>
                <Form.Item name="consultationReason">
                  <div>
                    <Input
                      placeholder="Reason"
                      value={consReason}
                      onChange={handleConsReasonChange}
                      className={`rounded-md`}
                    />

                    {consultationReasonList.length > 0 && (
                      <ul className="absolute top-12 left-0 w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20">
                        {consultationReasonList.map((reason, index) => (
                          <li
                            onClick={() => handleConsSelectChange(reason)}
                            key={index}
                            className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                          >
                            {reason.chiefComplaint}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </Form.Item>
              </div>
            </Col>
            {!hidePayFields && (
              <Col className={`${true ? "block" : "hidden"}`} span={12}>
                <div className="relative mt-2">
                  <span className="absolute -top-3 z-10 left-2 bg-white px-1 ">
                    Enter Fees
                  </span>
                  <Form.Item
                    name="consultationFee"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Total Amount!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Amount" />
                  </Form.Item>
                </div>
              </Col>
            )}
          </Row>
        </div>
        {!hidePayFields && (
          <div className="bg-white rounded-lg  p-3 mt-5 shadow-lg">
            <Row gutter={24}>
              <Col span={12}>
                <div className="relative mt-2">
                  <span className="absolute -top-2 z-10 left-2 px-1 ">
                    Payment
                  </span>
                  <Form.Item
                    name="paymentConsultation"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Payment Consultation!",
                      },
                    ]}
                  >
                    <Radio.Group
                      className="mt-5"
                      disabled={
                        paymentType === "Cash" ||
                        paymentType === "VirtualCash" ||
                        paymentType === "Digital"
                          ? true
                          : false
                      }
                    >
                      <Radio value="BC" className="text-black">
                        Before
                      </Radio>
                      <Radio value="AC" className="text-black">
                        After
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </Col>
              <Col span={12}>
                <div className="relative mt-3">
                  <span className="absolute -top-2 z-10 left-3 bg-white px-1  text-xs">
                    Payment Type <span className="text-red-500">*</span>
                  </span>

                  <Form.Item
                    name="paymentType"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Payment Type!",
                      },
                    ]}
                  >
                    <Select
                      defaultValue={"Cash"}
                      showSearch
                      className="w-full text-xs"
                      placeholder="Search to Payment mode"
                      onChange={onPaymentTypeChange}
                    >
                      <Select.Option value="Cash">Cash</Select.Option>
                      <Select.Option value="Digital">
                        Digital Payment
                      </Select.Option>
                      {/* <Select.Option
                        className="text-[#A0A2A3] text-xs"
                        value="VirtualCash"
                      >
                        Virtual Cash
                      </Select.Option> */}
                    </Select>
                  </Form.Item>
                </div>
              </Col>

              {paymentType == "Cash" && (
                <>
                  <Col>
                    <Form.Item name="">
                      <div>
                        <Checkbox
                          checked={paymentReceived}
                          className="mr-2"
                          style={{ color: "#189FAA" }}
                          onChange={onPaymentStatusChange}
                        />
                        Payment Received
                      </div>
                    </Form.Item>
                  </Col>
                  <Col span={12}></Col>
                </>
              )}
              {paymentType == "VirtualCash" && (
                <div className="mt-3 text-[#A0A2A3] text-xs flex gap-2 font-semibold">
                  <span className=" text-black">Wallet Balance :</span>
                  <span className="text-blue-400">{walletAmount}</span>
                </div>
              )}
            </Row>
          </div>
        )}
        <Form.Item>
          <div className="flex gap-2 justify-end mt-5">
            <button
              className="border rounded-lg bg-white text-sm w-20"
              onClick={handleCancelClick}
            >
              Cancel
            </button>
            {paymentType == "Digital" ? (
              <>
                <button
                  className="bg-brand-primaryColor border rounded-lg  w-40 p-2 text-sm text-white"
                  type="primary"
                  disabled={save}
                  htmlType="submit"
                  onClick={() => handleSubmitType("3")}
                >
                  Share Payment Link
                </button>
                <button
                  className="border rounded-lg bg-brand-primaryColor w-28 text-white"
                  type="primary"
                  disabled={save}
                  htmlType="submit"
                  onClick={() => handleSubmitType("1")}
                >
                  {callType === "APPT_VIDEO" ? "Pay Now" : "Pay & Schedule"}
                </button>
                <button
                  className="border bg-brand-primaryColor  rounded-lg text-white p-2 text-sm"
                  type="primary"
                  htmlType="submit"
                  disabled={save}
                  onClick={() => handleSubmitType("2")}
                >
                  {callType === "APPT_VIDEO" ? "Send Invite" : "Schedule"}
                </button>
              </>
            ) : (
              <>
                <button
                  className="border bg-brand-primaryColor rounded-lg text-white p-2 text-sm"
                  type="primary"
                  htmlType="submit"
                  disabled={save}
                  onClick={() => handleSubmitType("2")}
                >
                  {callType === "APPT_VIDEO" ? "Send Invite" : "Schedule"}
                </button>
              </>
            )}
          </div>
        </Form.Item>
      </Form>
      <Modal
        footer={[]}
        title={<div className="font-bold">Follow-up Visit</div>}
        open={visitModal}
        onCancel={() => {
          setVisitModal(false);
        }}
        width={"30%"}
      >
        <div className="flex items-center  mt-10 ">
          This patient is Eligible for free follow up visit do you want to
          proceed
        </div>
        <div className="flex justify-end border-brand-colorBorder gap-3 mt-10">
          <button
            className="h-10 text-white rounded-md font-bold px-8"
            onClick={cancelFollowUp}
          >
            No
          </button>
          <button
            onClick={() => {
              setVisitModal(false);
              if (selectedPatient) {
                form.setFieldsValue({
                  ...selectedPatient,
                });
              }
              setHidePayFields(true);
              setIsVisible(false);
              setSave(false);
            }}
            className="h-10 text-white bg-brand-primaryColor rounded-md font-bold px-10"
          >
            Ok
          </button>
        </div>
      </Modal>
    </div>
  );
}

export default AddExistingPatient;
